var _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _rect5, _rect6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFreshLock = function SvgFreshLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 22,
    width: 42,
    height: 76,
    rx: 6,
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 64,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 75a2 2 0 00-2 2v3.416A5.001 5.001 0 0060 90a5 5 0 002-9.584V77a2 2 0 00-2-2z",
    fill: "#F8F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80.416l.4.916.6-.262v-.654h-1zm4 0h-1v.654l.6.262.4-.916zM59 77a1 1 0 011-1v-2a3 3 0 00-3 3h2zm0 3.416V77h-2v3.416h2zM56 85c0-1.639.986-3.05 2.4-3.668l-.8-1.832A6.001 6.001 0 0054 85h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-2.4-3.668A4.001 4.001 0 0164 85h2a6.001 6.001 0 00-3.6-5.5l-.8 1.832zM61 77v3.416h2V77h-2zm-1-1a1 1 0 011 1h2a3 3 0 00-3-3v2z",
    fill: "#332C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 54,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 65a2 2 0 00-2 2v3.416A5.001 5.001 0 0039 80a5 5 0 002-9.584V67a2 2 0 00-2-2z",
    fill: "#F8F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70.416l.4.916.6-.262v-.654h-1zm4 0h-1v.654l.6.262.4-.916zM38 67a1 1 0 011-1v-2a3 3 0 00-3 3h2zm0 3.416V67h-2v3.416h2zM35 75c0-1.639.986-3.05 2.4-3.668l-.8-1.832A6.001 6.001 0 0033 75h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-2.4-3.668A4.001 4.001 0 0143 75h2a6.001 6.001 0 00-3.6-5.5l-.8 1.832zM40 67v3.416h2V67h-2zm-1-1a1 1 0 011 1h2a3 3 0 00-3-3v2z",
    fill: "#332C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 32,
    width: 12,
    height: 54,
    rx: 6,
    transform: "rotate(90 108 32)",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 44,
    width: 12,
    height: 12,
    rx: 6,
    transform: "rotate(-180 66 44)",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2
  })));
};

export default SvgFreshLock;